import axios from "axios/index";
import { token } from "@/store/modules/account";
import { Params } from "@/types";
// import {i18n} from "../main";

export const apiLink = () => {
	return process.env.VUE_APP_API_LINK;
};

export const prepareQueryParameters = (parameters: Params = {}) => {
	let params = new URLSearchParams({});

	Object.entries(parameters).forEach(([key, value]) => {
		if (value !== undefined && value !== null) {
			if (value instanceof Date) {
				params.set(key, value.toISOString());
			} else {
				params.set(key, value.toString());
			}
		}
	});

	return new URLSearchParams(params).toString();
};

export default {
	getAxiosConfig(queryParams: any = {}) {
		const UNAUTHORIZED = 401;
		axios.defaults.headers.common["Authorization"] = token();
		axios.interceptors.response.use(
			(response) => response,
			(error) => {
				const { status } = error.response;
				if (status === UNAUTHORIZED) {
					console.log("validate login");
				}
				return Promise.reject(error);
			}
		);

		if (process.env.NODE_ENV === "development") {
			//queryParams.XDEBUG_SESSION_START = "TP";
		}
		// queryParams.lang = i18n.locale;
		return {
			withCredentials: true,
			params: queryParams,
		};
	},

	get(link: string) {
		return axios.get(apiLink() + link, this.getAxiosConfig());
	},

	getInNewTab(link: string) {
		window.open(apiLink() + link, "_blank");
	},

	getRequest(store: any, url: string) {
		return new Promise((resolve, reject) => {
			this.get(url)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error.hasOwnProperty("response") ? error.response : error);
				});
		});
	},

	post(link: string, data = {}) {
		return axios.post(apiLink() + link, data, this.getAxiosConfig());
	},

	put(link: string, data = {}) {
		return axios.put(apiLink() + link, data, this.getAxiosConfig());
	},

	putWithNotification(store: any, link: string, data = {}, name: any = "Item") {
		return new Promise((resolve, reject) => {
			this.put(link, data)
				.then((response) => {
					// store.dispatch("alert/success", name, {
					// 	root: true,
					// });
					resolve(response.data);
				})
				.catch((error) => {
					store.dispatch("alert/warning", error.response.data.status, { root: true });
					reject(error.response);
				});
		});
	},

	postWithNotification(store: any, link: string, data = {}, name: any = "Item") {
		return new Promise((resolve, reject) => {
			this.post(link, data)
				.then((response) => {
					// if (name !== false) {
					// 	store.dispatch("alert/success", name, {
					// 		root: true,
					// 	});
					// }
					resolve(response.data);
				})
				.catch((error) => {
					if (name !== false) {
						store.dispatch("alert/warning", error.response.data.status, { root: true });
					}
					reject(error.response);
				});
		});
	},

	delete(link: string) {
		return axios.delete(apiLink() + link, this.getAxiosConfig());
	},
};
